import { useEffect, useState } from 'react'

import { useDashboardFeatureFlags, useDashboardPermissions } from '@components'
import { useDashboardStorage } from '@hooks/useDashboardStorage'
import { useOrdersStatisticsQuery } from '@hooks/useOrdersQuery/useOrdersStatisticsQuery'

export const useLaunchStrategyVisibility = () => {
  const { dashboardStorage } = useDashboardStorage()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const [dismissed, setDismissed] = useState(false)
  const { hasPermission } = useDashboardPermissions()

  const { getOrdersStatisticsQuery } = useOrdersStatisticsQuery([{ types: ['COMMON'] }], {
    staleTime: Infinity,
    enabled: hasPermission('contributions.orders.view'),
  })

  const isEnabled =
    dashboardFeatureFlags.launchStrategy.enabled && (getOrdersStatisticsQuery.data?.value ?? 0) < 10

  useEffect(() => {
    const isDismissed = dashboardStorage.get('launchStrategy.dismiss')
    if (isDismissed) {
      setDismissed(true)
    }
  }, [dashboardStorage])

  const handleOnDismiss = () => {
    setDismissed(true)
    dashboardStorage.set('launchStrategy.dismiss', true)
  }

  return {
    visible: isEnabled && !dismissed,
    onDismiss: handleOnDismiss,
  }
}
